import * as AUTHACTIONS from '../../actions/auth.action'

const initialState = {
    token: null,
    loading: false,
    success: false,
    failure: false,
}

export default function returnstate(state = initialState, action) {

    switch (action.type) {
        case AUTHACTIONS.GET_ACCESS_TOKEN.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false,
            };
        case AUTHACTIONS.GET_ACCESS_TOKEN.SUCCESS:     
        return {
                ...state,
                token: action.payload,
                loading: false,
                success: true,
                failure: false
            };

        case AUTHACTIONS.GET_ACCESS_TOKEN.FAILURE:
            return {
                ...state,
                token: null,
                loading: false,
                success: false,
                failure: true,
            };
        default: return state
    }
}